import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { HttpClient } from "@angular/common/http";

export interface IStorageHistory
{
    _currencyId: number;
    _txHash: string;
    _amount: string;
    _fee: string;
    _feePrice: string;
    _from: string;
    _to: string;
    _timestamp: number;
    _state: TX_STATE.PENDING | TX_STATE.FAILED | TX_STATE.SUCCESS;
    _chainId: number;
    _nonce: number;
    _data: string;
    _value: string;
}

export enum TX_STATE
{
    PENDING = 0,
    SUCCESS = 1,
    FAILED = 2,
}

@Injectable({
    providedIn: 'root'
})
export class TransactionHistoryApi
{

    constructor(
        private storage: StorageService,
        private http: HttpClient
    ) { }

    //Gets txByHash
    public async get(_txHash: string): Promise<any>
    {
        try
        {
            return await this.http.get(`/api/history/${ _txHash }`).toPromise();
        }
        catch (error)
        {
            return [];
        }
    }

    public async getByAddressCurrency(_walletAddress: string, _currencyId: number): Promise<any>
    {
        try
        {
            return await this.http.get(`/api/history/${ _walletAddress }/${ _currencyId }`).toPromise();
        }
        catch (error)
        {
            return [];
        }
    }
    // _currency_id: number, _tx_hash:string, _amount:string, _fee:string, _fee_price:string, _from:string, _to:string, _timestamp:number, _state: TX_STATE
    public async setTransaction(tx_history: IStorageHistory)
    {
        try
        {
            return await this.http.post(`/api/history`, {
                currencyId: tx_history._currencyId,
                amount: tx_history._amount,
                fee: tx_history._fee,
                feePrice: tx_history._feePrice,
                from: tx_history._from,
                to: tx_history._to,
                timestamp: tx_history._timestamp,
                state: tx_history._state,
                txHash: tx_history._txHash,
                chainId: tx_history._chainId,
                nonce: tx_history._nonce,
                data: tx_history._data,
                value: tx_history._value,
            }).toPromise();
        } catch (error)
        {
            return undefined;
        }
    }

    public async updateState(_txHash: string, _state: TX_STATE, _failReason: string = '-')
    {
        try
        {
            return await this.http.post(`/api/history/update`, {
                txHash: _txHash,
                state: _state,
                failReason: _failReason
            }).toPromise();
        } catch (error)
        {
            return undefined;
        }
    }

    public async updateHash(_txHash: string, _newTxHash: string, _feePrice: string, _feeLimit: string)
    {
        try
        {
            return await this.http.post(`/api/history/updateHash`, {
                txHash: _txHash,
                newTxHash: _newTxHash,
                feePrice: _feePrice,
                feeLimit: _feeLimit
            }).toPromise();
        } catch (error)
        {
            return undefined;
        }
    }

}
